import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import omit from 'lodash/omit';

import {EMPTY_EVENT_ENTRY} from 'common/widgets/query-entry-section/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {ListOperator, PropertyType, ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {FullLengthDateRange} from 'common/widgets/date-range-picker/models/full-length-date-range';

import {AnchorsFlowsReport} from './types';
import {FlowsReport} from './report';

/** Converts params of AnchorsFlowsReport to FlowsReport */
export function convertAnchorFlowsToFlowsReport(flowsReport: AnchorsFlowsReport): Partial<FlowsReport> {
  flowsReport = {
    anchors: [],
    dateRange: new FullLengthDateRange(),
    filters: [],
    filterByCohort: null,
    groupByCohorts: [],
    ...flowsReport,
  };

  const {anchors, filterByCohort, groupByCohorts} = flowsReport;
  const attrs = {
    dateRange: flowsReport.dateRange,
    events: [],
    groupBy: [],
    filters: (flowsReport.filters || []).map((filter) => new PropertyFilter(filter)),
    reverse: anchors.some((anchor) => anchor && anchor.reverse),
    ...omit(flowsReport, `anchors`, `filterByCohort`, `groupByCohorts`),
  };

  attrs.events = anchors.map((anchor) => {
    if (isEmpty(anchor)) {
      return null;
    }

    return {
      ...EMPTY_EVENT_ENTRY,
      ...pick(anchor, [`forward`, `reverse`]),
      event: {
        ...anchor.event,
      },
    };
  });

  if (!isEmpty(filterByCohort)) {
    const cohort = filterByCohort;
    attrs.filters = [
      ...attrs.filters,
      new PropertyFilter({
        filterOperator: cohort.negated ? ListOperator.DoesNotContain : ListOperator.Contains,
        filterValue: [
          {
            cohort: {
              id: cohort.id,
              negated: false,
            },
          },
        ],
        propertyType: PropertyType.List,
        resourceType: ResourceType.Cohort,
      }),
    ];
  } else if (!isEmpty(groupByCohorts)) {
    attrs.groupBy = [
      [
        ...groupByCohorts.map((cohort) => ({
          cohort: {
            ...cohort,
            negated: false,
          },
        })),
      ],
    ];
  }

  // prune out empty events
  if (isEmpty(attrs.events)) {
    delete attrs.events;
  }

  return attrs;
}
